module.exports = __webpack_public_path__ + "img/infestlarge.1af54ad7.jpg";